import React from 'react';
import './SkeletonLoader.css';

// Simple skeleton loader without shimmer effects
export const SkeletonBox = ({ width, height, className = '' }) => (
  <div 
    className={`skeleton-box ${className}`}
    style={{ width, height }}
  />
);

export const SkeletonText = ({ lines = 1, width = '100%', className = '' }) => (
  <div className={`skeleton-text ${className}`}>
    {Array.from({ length: lines }).map((_, i) => (
      <div 
        key={i}
        className="skeleton-line"
        style={{ 
          width: i === lines - 1 ? '80%' : width,
          marginBottom: i < lines - 1 ? '8px' : '0'
        }}
      />
    ))}
  </div>
);

export const SkeletonCard = ({ className = '' }) => (
  <div className={`skeleton-card ${className}`}>
    <SkeletonBox width="100%" height="200px" />
    <div style={{ padding: '16px' }}>
      <SkeletonText lines={2} width="100%" />
      <SkeletonBox width="60%" height="20px" className="skeleton-margin-top" />
    </div>
  </div>
);

export const SkeletonGrid = ({ count = 4, className = '' }) => (
  <div className={`skeleton-grid ${className}`}>
    {Array.from({ length: count }).map((_, i) => (
      <SkeletonCard key={i} />
    ))}
  </div>
);

export const SkeletonList = ({ count = 5, className = '' }) => (
  <div className={`skeleton-list ${className}`}>
    {Array.from({ length: count }).map((_, i) => (
      <div key={i} className="skeleton-list-item">
        <SkeletonBox width="60px" height="60px" />
        <div style={{ flex: 1, marginLeft: '16px' }}>
          <SkeletonText lines={2} width="100%" />
        </div>
      </div>
    ))}
  </div>
);

// Default export for convenience
const SkeletonLoader = {
  Box: SkeletonBox,
  Text: SkeletonText,
  Card: SkeletonCard,
  Grid: SkeletonGrid,
  List: SkeletonList
};

export default SkeletonLoader;

